/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DateAlert,
  ExamDatesAlertsListParams,
  ExamDatesMeRetrieveParams,
  ExamDatesMeta,
  ExamDatesMetaRetrieveParams,
  ExamDatesNearMe,
  ExamDatesOk,
  ExamDatesResearchesListParams,
  ExamDatesSessionsListParams,
  ExamSession,
  ExamSessionImportRequest,
  ExamSessionImportResult,
  ExamSessionRequest,
  MyAlertRequest,
  PaginatedDateAlertList,
  PaginatedExamSessionList,
  PaginatedSessionResearchList,
  PatchedExamSessionRequest,
  ReminderRequest,
  ResearchRequestRequest,
  SessionResearch
} from '.././model';

import { apiFetch } from '../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * The « tell me about new dates » sign-ups (each one is also a CRM lead).
 */
export type examDatesAlertsListResponse200 = {
  data: PaginatedDateAlertList
  status: 200
}
    
export type examDatesAlertsListResponseSuccess = (examDatesAlertsListResponse200) & {
  headers: Headers;
};
;

export type examDatesAlertsListResponse = (examDatesAlertsListResponseSuccess)

export const getExamDatesAlertsListUrl = (params?: ExamDatesAlertsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/exam-dates/alerts/?${stringifiedParams}` : `/api/v1/exam-dates/alerts/`
}

export const examDatesAlertsList = async (params?: ExamDatesAlertsListParams, options?: RequestInit): Promise<examDatesAlertsListResponse> => {
  
  return apiFetch<examDatesAlertsListResponse>(getExamDatesAlertsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getExamDatesAlertsListQueryKey = (params?: ExamDatesAlertsListParams,) => {
    return [
    `/api/v1/exam-dates/alerts/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getExamDatesAlertsListQueryOptions = <TData = Awaited<ReturnType<typeof examDatesAlertsList>>, TError = unknown>(params?: ExamDatesAlertsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesAlertsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExamDatesAlertsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof examDatesAlertsList>>> = ({ signal }) => examDatesAlertsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof examDatesAlertsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExamDatesAlertsListQueryResult = NonNullable<Awaited<ReturnType<typeof examDatesAlertsList>>>
export type ExamDatesAlertsListQueryError = unknown


export function useExamDatesAlertsList<TData = Awaited<ReturnType<typeof examDatesAlertsList>>, TError = unknown>(
 params: undefined |  ExamDatesAlertsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesAlertsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof examDatesAlertsList>>,
          TError,
          Awaited<ReturnType<typeof examDatesAlertsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExamDatesAlertsList<TData = Awaited<ReturnType<typeof examDatesAlertsList>>, TError = unknown>(
 params?: ExamDatesAlertsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesAlertsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof examDatesAlertsList>>,
          TError,
          Awaited<ReturnType<typeof examDatesAlertsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExamDatesAlertsList<TData = Awaited<ReturnType<typeof examDatesAlertsList>>, TError = unknown>(
 params?: ExamDatesAlertsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesAlertsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useExamDatesAlertsList<TData = Awaited<ReturnType<typeof examDatesAlertsList>>, TError = unknown>(
 params?: ExamDatesAlertsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesAlertsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExamDatesAlertsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The « tell me about new dates » sign-ups (each one is also a CRM lead).
 */
export type examDatesAlertsRetrieveResponse200 = {
  data: DateAlert
  status: 200
}
    
export type examDatesAlertsRetrieveResponseSuccess = (examDatesAlertsRetrieveResponse200) & {
  headers: Headers;
};
;

export type examDatesAlertsRetrieveResponse = (examDatesAlertsRetrieveResponseSuccess)

export const getExamDatesAlertsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/exam-dates/alerts/${id}/`
}

export const examDatesAlertsRetrieve = async (id: string, options?: RequestInit): Promise<examDatesAlertsRetrieveResponse> => {
  
  return apiFetch<examDatesAlertsRetrieveResponse>(getExamDatesAlertsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getExamDatesAlertsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/exam-dates/alerts/${id}/`
    ] as const;
    }

    
export const getExamDatesAlertsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof examDatesAlertsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesAlertsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExamDatesAlertsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof examDatesAlertsRetrieve>>> = ({ signal }) => examDatesAlertsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof examDatesAlertsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExamDatesAlertsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof examDatesAlertsRetrieve>>>
export type ExamDatesAlertsRetrieveQueryError = unknown


export function useExamDatesAlertsRetrieve<TData = Awaited<ReturnType<typeof examDatesAlertsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesAlertsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof examDatesAlertsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof examDatesAlertsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExamDatesAlertsRetrieve<TData = Awaited<ReturnType<typeof examDatesAlertsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesAlertsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof examDatesAlertsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof examDatesAlertsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExamDatesAlertsRetrieve<TData = Awaited<ReturnType<typeof examDatesAlertsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesAlertsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useExamDatesAlertsRetrieve<TData = Awaited<ReturnType<typeof examDatesAlertsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesAlertsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExamDatesAlertsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * « Prochaines sessions près de chez vous »: the verified sessions of the learner's country
for an exam (and a Goethe level), the cities with a centre, the registration guide.
 */
export type examDatesMeRetrieveResponse200 = {
  data: ExamDatesNearMe
  status: 200
}
    
export type examDatesMeRetrieveResponseSuccess = (examDatesMeRetrieveResponse200) & {
  headers: Headers;
};
;

export type examDatesMeRetrieveResponse = (examDatesMeRetrieveResponseSuccess)

export const getExamDatesMeRetrieveUrl = (params?: ExamDatesMeRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/exam-dates/me/?${stringifiedParams}` : `/api/v1/exam-dates/me/`
}

export const examDatesMeRetrieve = async (params?: ExamDatesMeRetrieveParams, options?: RequestInit): Promise<examDatesMeRetrieveResponse> => {
  
  return apiFetch<examDatesMeRetrieveResponse>(getExamDatesMeRetrieveUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getExamDatesMeRetrieveQueryKey = (params?: ExamDatesMeRetrieveParams,) => {
    return [
    `/api/v1/exam-dates/me/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getExamDatesMeRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof examDatesMeRetrieve>>, TError = unknown>(params?: ExamDatesMeRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesMeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExamDatesMeRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof examDatesMeRetrieve>>> = ({ signal }) => examDatesMeRetrieve(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof examDatesMeRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExamDatesMeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof examDatesMeRetrieve>>>
export type ExamDatesMeRetrieveQueryError = unknown


export function useExamDatesMeRetrieve<TData = Awaited<ReturnType<typeof examDatesMeRetrieve>>, TError = unknown>(
 params: undefined |  ExamDatesMeRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesMeRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof examDatesMeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof examDatesMeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExamDatesMeRetrieve<TData = Awaited<ReturnType<typeof examDatesMeRetrieve>>, TError = unknown>(
 params?: ExamDatesMeRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesMeRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof examDatesMeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof examDatesMeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExamDatesMeRetrieve<TData = Awaited<ReturnType<typeof examDatesMeRetrieve>>, TError = unknown>(
 params?: ExamDatesMeRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesMeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useExamDatesMeRetrieve<TData = Awaited<ReturnType<typeof examDatesMeRetrieve>>, TError = unknown>(
 params?: ExamDatesMeRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesMeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExamDatesMeRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * « Dates à venir : prévenez-moi » from the learner's space (their e-mail, consent).
 */
export type examDatesMeAlertsCreateResponse201 = {
  data: ExamDatesOk
  status: 201
}
    
export type examDatesMeAlertsCreateResponseSuccess = (examDatesMeAlertsCreateResponse201) & {
  headers: Headers;
};
;

export type examDatesMeAlertsCreateResponse = (examDatesMeAlertsCreateResponseSuccess)

export const getExamDatesMeAlertsCreateUrl = () => {


  

  return `/api/v1/exam-dates/me/alerts/`
}

export const examDatesMeAlertsCreate = async (myAlertRequest: MyAlertRequest, options?: RequestInit): Promise<examDatesMeAlertsCreateResponse> => {
  
  return apiFetch<examDatesMeAlertsCreateResponse>(getExamDatesMeAlertsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      myAlertRequest,)
  }
);}




export const getExamDatesMeAlertsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examDatesMeAlertsCreate>>, TError,{data: MyAlertRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof examDatesMeAlertsCreate>>, TError,{data: MyAlertRequest}, TContext> => {

const mutationKey = ['examDatesMeAlertsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof examDatesMeAlertsCreate>>, {data: MyAlertRequest}> = (props) => {
          const {data} = props ?? {};

          return  examDatesMeAlertsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExamDatesMeAlertsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof examDatesMeAlertsCreate>>>
    export type ExamDatesMeAlertsCreateMutationBody = MyAlertRequest
    export type ExamDatesMeAlertsCreateMutationError = unknown

    export const useExamDatesMeAlertsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examDatesMeAlertsCreate>>, TError,{data: MyAlertRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof examDatesMeAlertsCreate>>,
        TError,
        {data: MyAlertRequest},
        TContext
      > => {

      const mutationOptions = getExamDatesMeAlertsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Remind me of the registration deadline of a session (J-7 and J-1, notification or e-mail).
 */
export type examDatesMeRemindersCreateResponse201 = {
  data: ExamDatesOk
  status: 201
}
    
export type examDatesMeRemindersCreateResponseSuccess = (examDatesMeRemindersCreateResponse201) & {
  headers: Headers;
};
;

export type examDatesMeRemindersCreateResponse = (examDatesMeRemindersCreateResponseSuccess)

export const getExamDatesMeRemindersCreateUrl = () => {


  

  return `/api/v1/exam-dates/me/reminders/`
}

export const examDatesMeRemindersCreate = async (reminderRequest: ReminderRequest, options?: RequestInit): Promise<examDatesMeRemindersCreateResponse> => {
  
  return apiFetch<examDatesMeRemindersCreateResponse>(getExamDatesMeRemindersCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      reminderRequest,)
  }
);}




export const getExamDatesMeRemindersCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examDatesMeRemindersCreate>>, TError,{data: ReminderRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof examDatesMeRemindersCreate>>, TError,{data: ReminderRequest}, TContext> => {

const mutationKey = ['examDatesMeRemindersCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof examDatesMeRemindersCreate>>, {data: ReminderRequest}> = (props) => {
          const {data} = props ?? {};

          return  examDatesMeRemindersCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExamDatesMeRemindersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof examDatesMeRemindersCreate>>>
    export type ExamDatesMeRemindersCreateMutationBody = ReminderRequest
    export type ExamDatesMeRemindersCreateMutationError = unknown

    export const useExamDatesMeRemindersCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examDatesMeRemindersCreate>>, TError,{data: ReminderRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof examDatesMeRemindersCreate>>,
        TError,
        {data: ReminderRequest},
        TContext
      > => {

      const mutationOptions = getExamDatesMeRemindersCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type examDatesMeRemindersDestroyResponse204 = {
  data: void
  status: 204
}
    
export type examDatesMeRemindersDestroyResponseSuccess = (examDatesMeRemindersDestroyResponse204) & {
  headers: Headers;
};
;

export type examDatesMeRemindersDestroyResponse = (examDatesMeRemindersDestroyResponseSuccess)

export const getExamDatesMeRemindersDestroyUrl = (sessionId: string,) => {


  

  return `/api/v1/exam-dates/me/reminders/${sessionId}/`
}

export const examDatesMeRemindersDestroy = async (sessionId: string, options?: RequestInit): Promise<examDatesMeRemindersDestroyResponse> => {
  
  return apiFetch<examDatesMeRemindersDestroyResponse>(getExamDatesMeRemindersDestroyUrl(sessionId),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getExamDatesMeRemindersDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examDatesMeRemindersDestroy>>, TError,{sessionId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof examDatesMeRemindersDestroy>>, TError,{sessionId: string}, TContext> => {

const mutationKey = ['examDatesMeRemindersDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof examDatesMeRemindersDestroy>>, {sessionId: string}> = (props) => {
          const {sessionId} = props ?? {};

          return  examDatesMeRemindersDestroy(sessionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExamDatesMeRemindersDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof examDatesMeRemindersDestroy>>>
    
    export type ExamDatesMeRemindersDestroyMutationError = unknown

    export const useExamDatesMeRemindersDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examDatesMeRemindersDestroy>>, TError,{sessionId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof examDatesMeRemindersDestroy>>,
        TError,
        {sessionId: string},
        TContext
      > => {

      const mutationOptions = getExamDatesMeRemindersDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Exams, countries and, for one country, the centres of each exam (selects of the screen).
 */
export type examDatesMetaRetrieveResponse200 = {
  data: ExamDatesMeta
  status: 200
}
    
export type examDatesMetaRetrieveResponseSuccess = (examDatesMetaRetrieveResponse200) & {
  headers: Headers;
};
;

export type examDatesMetaRetrieveResponse = (examDatesMetaRetrieveResponseSuccess)

export const getExamDatesMetaRetrieveUrl = (params?: ExamDatesMetaRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/exam-dates/meta/?${stringifiedParams}` : `/api/v1/exam-dates/meta/`
}

export const examDatesMetaRetrieve = async (params?: ExamDatesMetaRetrieveParams, options?: RequestInit): Promise<examDatesMetaRetrieveResponse> => {
  
  return apiFetch<examDatesMetaRetrieveResponse>(getExamDatesMetaRetrieveUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getExamDatesMetaRetrieveQueryKey = (params?: ExamDatesMetaRetrieveParams,) => {
    return [
    `/api/v1/exam-dates/meta/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getExamDatesMetaRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof examDatesMetaRetrieve>>, TError = unknown>(params?: ExamDatesMetaRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesMetaRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExamDatesMetaRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof examDatesMetaRetrieve>>> = ({ signal }) => examDatesMetaRetrieve(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof examDatesMetaRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExamDatesMetaRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof examDatesMetaRetrieve>>>
export type ExamDatesMetaRetrieveQueryError = unknown


export function useExamDatesMetaRetrieve<TData = Awaited<ReturnType<typeof examDatesMetaRetrieve>>, TError = unknown>(
 params: undefined |  ExamDatesMetaRetrieveParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesMetaRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof examDatesMetaRetrieve>>,
          TError,
          Awaited<ReturnType<typeof examDatesMetaRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExamDatesMetaRetrieve<TData = Awaited<ReturnType<typeof examDatesMetaRetrieve>>, TError = unknown>(
 params?: ExamDatesMetaRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesMetaRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof examDatesMetaRetrieve>>,
          TError,
          Awaited<ReturnType<typeof examDatesMetaRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExamDatesMetaRetrieve<TData = Awaited<ReturnType<typeof examDatesMetaRetrieve>>, TError = unknown>(
 params?: ExamDatesMetaRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesMetaRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useExamDatesMetaRetrieve<TData = Awaited<ReturnType<typeof examDatesMetaRetrieve>>, TError = unknown>(
 params?: ExamDatesMetaRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesMetaRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExamDatesMetaRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type examDatesResearchesListResponse200 = {
  data: PaginatedSessionResearchList
  status: 200
}
    
export type examDatesResearchesListResponseSuccess = (examDatesResearchesListResponse200) & {
  headers: Headers;
};
;

export type examDatesResearchesListResponse = (examDatesResearchesListResponseSuccess)

export const getExamDatesResearchesListUrl = (params?: ExamDatesResearchesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/exam-dates/researches/?${stringifiedParams}` : `/api/v1/exam-dates/researches/`
}

export const examDatesResearchesList = async (params?: ExamDatesResearchesListParams, options?: RequestInit): Promise<examDatesResearchesListResponse> => {
  
  return apiFetch<examDatesResearchesListResponse>(getExamDatesResearchesListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getExamDatesResearchesListQueryKey = (params?: ExamDatesResearchesListParams,) => {
    return [
    `/api/v1/exam-dates/researches/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getExamDatesResearchesListQueryOptions = <TData = Awaited<ReturnType<typeof examDatesResearchesList>>, TError = unknown>(params?: ExamDatesResearchesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesResearchesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExamDatesResearchesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof examDatesResearchesList>>> = ({ signal }) => examDatesResearchesList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof examDatesResearchesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExamDatesResearchesListQueryResult = NonNullable<Awaited<ReturnType<typeof examDatesResearchesList>>>
export type ExamDatesResearchesListQueryError = unknown


export function useExamDatesResearchesList<TData = Awaited<ReturnType<typeof examDatesResearchesList>>, TError = unknown>(
 params: undefined |  ExamDatesResearchesListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesResearchesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof examDatesResearchesList>>,
          TError,
          Awaited<ReturnType<typeof examDatesResearchesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExamDatesResearchesList<TData = Awaited<ReturnType<typeof examDatesResearchesList>>, TError = unknown>(
 params?: ExamDatesResearchesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesResearchesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof examDatesResearchesList>>,
          TError,
          Awaited<ReturnType<typeof examDatesResearchesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExamDatesResearchesList<TData = Awaited<ReturnType<typeof examDatesResearchesList>>, TError = unknown>(
 params?: ExamDatesResearchesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesResearchesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useExamDatesResearchesList<TData = Awaited<ReturnType<typeof examDatesResearchesList>>, TError = unknown>(
 params?: ExamDatesResearchesListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesResearchesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExamDatesResearchesListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type examDatesResearchesRetrieveResponse200 = {
  data: SessionResearch
  status: 200
}
    
export type examDatesResearchesRetrieveResponseSuccess = (examDatesResearchesRetrieveResponse200) & {
  headers: Headers;
};
;

export type examDatesResearchesRetrieveResponse = (examDatesResearchesRetrieveResponseSuccess)

export const getExamDatesResearchesRetrieveUrl = (id: string,) => {


  

  return `/api/v1/exam-dates/researches/${id}/`
}

export const examDatesResearchesRetrieve = async (id: string, options?: RequestInit): Promise<examDatesResearchesRetrieveResponse> => {
  
  return apiFetch<examDatesResearchesRetrieveResponse>(getExamDatesResearchesRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getExamDatesResearchesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/exam-dates/researches/${id}/`
    ] as const;
    }

    
export const getExamDatesResearchesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof examDatesResearchesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesResearchesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExamDatesResearchesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof examDatesResearchesRetrieve>>> = ({ signal }) => examDatesResearchesRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof examDatesResearchesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExamDatesResearchesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof examDatesResearchesRetrieve>>>
export type ExamDatesResearchesRetrieveQueryError = unknown


export function useExamDatesResearchesRetrieve<TData = Awaited<ReturnType<typeof examDatesResearchesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesResearchesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof examDatesResearchesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof examDatesResearchesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExamDatesResearchesRetrieve<TData = Awaited<ReturnType<typeof examDatesResearchesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesResearchesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof examDatesResearchesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof examDatesResearchesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExamDatesResearchesRetrieve<TData = Awaited<ReturnType<typeof examDatesResearchesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesResearchesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useExamDatesResearchesRetrieve<TData = Awaited<ReturnType<typeof examDatesResearchesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesResearchesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExamDatesResearchesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Official sessions. Deleting is only possible while « to verify » (a typing error); a
verified or past session is kept (history).
 */
export type examDatesSessionsListResponse200 = {
  data: PaginatedExamSessionList
  status: 200
}
    
export type examDatesSessionsListResponseSuccess = (examDatesSessionsListResponse200) & {
  headers: Headers;
};
;

export type examDatesSessionsListResponse = (examDatesSessionsListResponseSuccess)

export const getExamDatesSessionsListUrl = (params?: ExamDatesSessionsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/exam-dates/sessions/?${stringifiedParams}` : `/api/v1/exam-dates/sessions/`
}

export const examDatesSessionsList = async (params?: ExamDatesSessionsListParams, options?: RequestInit): Promise<examDatesSessionsListResponse> => {
  
  return apiFetch<examDatesSessionsListResponse>(getExamDatesSessionsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getExamDatesSessionsListQueryKey = (params?: ExamDatesSessionsListParams,) => {
    return [
    `/api/v1/exam-dates/sessions/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getExamDatesSessionsListQueryOptions = <TData = Awaited<ReturnType<typeof examDatesSessionsList>>, TError = unknown>(params?: ExamDatesSessionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesSessionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExamDatesSessionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof examDatesSessionsList>>> = ({ signal }) => examDatesSessionsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof examDatesSessionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExamDatesSessionsListQueryResult = NonNullable<Awaited<ReturnType<typeof examDatesSessionsList>>>
export type ExamDatesSessionsListQueryError = unknown


export function useExamDatesSessionsList<TData = Awaited<ReturnType<typeof examDatesSessionsList>>, TError = unknown>(
 params: undefined |  ExamDatesSessionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesSessionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof examDatesSessionsList>>,
          TError,
          Awaited<ReturnType<typeof examDatesSessionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExamDatesSessionsList<TData = Awaited<ReturnType<typeof examDatesSessionsList>>, TError = unknown>(
 params?: ExamDatesSessionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesSessionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof examDatesSessionsList>>,
          TError,
          Awaited<ReturnType<typeof examDatesSessionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExamDatesSessionsList<TData = Awaited<ReturnType<typeof examDatesSessionsList>>, TError = unknown>(
 params?: ExamDatesSessionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesSessionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useExamDatesSessionsList<TData = Awaited<ReturnType<typeof examDatesSessionsList>>, TError = unknown>(
 params?: ExamDatesSessionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesSessionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExamDatesSessionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Official sessions. Deleting is only possible while « to verify » (a typing error); a
verified or past session is kept (history).
 */
export type examDatesSessionsCreateResponse201 = {
  data: ExamSession
  status: 201
}
    
export type examDatesSessionsCreateResponseSuccess = (examDatesSessionsCreateResponse201) & {
  headers: Headers;
};
;

export type examDatesSessionsCreateResponse = (examDatesSessionsCreateResponseSuccess)

export const getExamDatesSessionsCreateUrl = () => {


  

  return `/api/v1/exam-dates/sessions/`
}

export const examDatesSessionsCreate = async (examSessionRequest: ExamSessionRequest, options?: RequestInit): Promise<examDatesSessionsCreateResponse> => {
  
  return apiFetch<examDatesSessionsCreateResponse>(getExamDatesSessionsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      examSessionRequest,)
  }
);}




export const getExamDatesSessionsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examDatesSessionsCreate>>, TError,{data: ExamSessionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof examDatesSessionsCreate>>, TError,{data: ExamSessionRequest}, TContext> => {

const mutationKey = ['examDatesSessionsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof examDatesSessionsCreate>>, {data: ExamSessionRequest}> = (props) => {
          const {data} = props ?? {};

          return  examDatesSessionsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExamDatesSessionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof examDatesSessionsCreate>>>
    export type ExamDatesSessionsCreateMutationBody = ExamSessionRequest
    export type ExamDatesSessionsCreateMutationError = unknown

    export const useExamDatesSessionsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examDatesSessionsCreate>>, TError,{data: ExamSessionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof examDatesSessionsCreate>>,
        TError,
        {data: ExamSessionRequest},
        TContext
      > => {

      const mutationOptions = getExamDatesSessionsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Official sessions. Deleting is only possible while « to verify » (a typing error); a
verified or past session is kept (history).
 */
export type examDatesSessionsRetrieveResponse200 = {
  data: ExamSession
  status: 200
}
    
export type examDatesSessionsRetrieveResponseSuccess = (examDatesSessionsRetrieveResponse200) & {
  headers: Headers;
};
;

export type examDatesSessionsRetrieveResponse = (examDatesSessionsRetrieveResponseSuccess)

export const getExamDatesSessionsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/exam-dates/sessions/${id}/`
}

export const examDatesSessionsRetrieve = async (id: string, options?: RequestInit): Promise<examDatesSessionsRetrieveResponse> => {
  
  return apiFetch<examDatesSessionsRetrieveResponse>(getExamDatesSessionsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getExamDatesSessionsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/exam-dates/sessions/${id}/`
    ] as const;
    }

    
export const getExamDatesSessionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof examDatesSessionsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesSessionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExamDatesSessionsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof examDatesSessionsRetrieve>>> = ({ signal }) => examDatesSessionsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof examDatesSessionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExamDatesSessionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof examDatesSessionsRetrieve>>>
export type ExamDatesSessionsRetrieveQueryError = unknown


export function useExamDatesSessionsRetrieve<TData = Awaited<ReturnType<typeof examDatesSessionsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesSessionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof examDatesSessionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof examDatesSessionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExamDatesSessionsRetrieve<TData = Awaited<ReturnType<typeof examDatesSessionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesSessionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof examDatesSessionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof examDatesSessionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExamDatesSessionsRetrieve<TData = Awaited<ReturnType<typeof examDatesSessionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesSessionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useExamDatesSessionsRetrieve<TData = Awaited<ReturnType<typeof examDatesSessionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examDatesSessionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExamDatesSessionsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Official sessions. Deleting is only possible while « to verify » (a typing error); a
verified or past session is kept (history).
 */
export type examDatesSessionsUpdateResponse200 = {
  data: ExamSession
  status: 200
}
    
export type examDatesSessionsUpdateResponseSuccess = (examDatesSessionsUpdateResponse200) & {
  headers: Headers;
};
;

export type examDatesSessionsUpdateResponse = (examDatesSessionsUpdateResponseSuccess)

export const getExamDatesSessionsUpdateUrl = (id: string,) => {


  

  return `/api/v1/exam-dates/sessions/${id}/`
}

export const examDatesSessionsUpdate = async (id: string,
    examSessionRequest: ExamSessionRequest, options?: RequestInit): Promise<examDatesSessionsUpdateResponse> => {
  
  return apiFetch<examDatesSessionsUpdateResponse>(getExamDatesSessionsUpdateUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      examSessionRequest,)
  }
);}




export const getExamDatesSessionsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examDatesSessionsUpdate>>, TError,{id: string;data: ExamSessionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof examDatesSessionsUpdate>>, TError,{id: string;data: ExamSessionRequest}, TContext> => {

const mutationKey = ['examDatesSessionsUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof examDatesSessionsUpdate>>, {id: string;data: ExamSessionRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  examDatesSessionsUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExamDatesSessionsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof examDatesSessionsUpdate>>>
    export type ExamDatesSessionsUpdateMutationBody = ExamSessionRequest
    export type ExamDatesSessionsUpdateMutationError = unknown

    export const useExamDatesSessionsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examDatesSessionsUpdate>>, TError,{id: string;data: ExamSessionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof examDatesSessionsUpdate>>,
        TError,
        {id: string;data: ExamSessionRequest},
        TContext
      > => {

      const mutationOptions = getExamDatesSessionsUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Official sessions. Deleting is only possible while « to verify » (a typing error); a
verified or past session is kept (history).
 */
export type examDatesSessionsPartialUpdateResponse200 = {
  data: ExamSession
  status: 200
}
    
export type examDatesSessionsPartialUpdateResponseSuccess = (examDatesSessionsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type examDatesSessionsPartialUpdateResponse = (examDatesSessionsPartialUpdateResponseSuccess)

export const getExamDatesSessionsPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/exam-dates/sessions/${id}/`
}

export const examDatesSessionsPartialUpdate = async (id: string,
    patchedExamSessionRequest: PatchedExamSessionRequest, options?: RequestInit): Promise<examDatesSessionsPartialUpdateResponse> => {
  
  return apiFetch<examDatesSessionsPartialUpdateResponse>(getExamDatesSessionsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedExamSessionRequest,)
  }
);}




export const getExamDatesSessionsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examDatesSessionsPartialUpdate>>, TError,{id: string;data: PatchedExamSessionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof examDatesSessionsPartialUpdate>>, TError,{id: string;data: PatchedExamSessionRequest}, TContext> => {

const mutationKey = ['examDatesSessionsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof examDatesSessionsPartialUpdate>>, {id: string;data: PatchedExamSessionRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  examDatesSessionsPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExamDatesSessionsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof examDatesSessionsPartialUpdate>>>
    export type ExamDatesSessionsPartialUpdateMutationBody = PatchedExamSessionRequest
    export type ExamDatesSessionsPartialUpdateMutationError = unknown

    export const useExamDatesSessionsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examDatesSessionsPartialUpdate>>, TError,{id: string;data: PatchedExamSessionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof examDatesSessionsPartialUpdate>>,
        TError,
        {id: string;data: PatchedExamSessionRequest},
        TContext
      > => {

      const mutationOptions = getExamDatesSessionsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Official sessions. Deleting is only possible while « to verify » (a typing error); a
verified or past session is kept (history).
 */
export type examDatesSessionsDestroyResponse204 = {
  data: void
  status: 204
}
    
export type examDatesSessionsDestroyResponseSuccess = (examDatesSessionsDestroyResponse204) & {
  headers: Headers;
};
;

export type examDatesSessionsDestroyResponse = (examDatesSessionsDestroyResponseSuccess)

export const getExamDatesSessionsDestroyUrl = (id: string,) => {


  

  return `/api/v1/exam-dates/sessions/${id}/`
}

export const examDatesSessionsDestroy = async (id: string, options?: RequestInit): Promise<examDatesSessionsDestroyResponse> => {
  
  return apiFetch<examDatesSessionsDestroyResponse>(getExamDatesSessionsDestroyUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getExamDatesSessionsDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examDatesSessionsDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof examDatesSessionsDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['examDatesSessionsDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof examDatesSessionsDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  examDatesSessionsDestroy(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExamDatesSessionsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof examDatesSessionsDestroy>>>
    
    export type ExamDatesSessionsDestroyMutationError = unknown

    export const useExamDatesSessionsDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examDatesSessionsDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof examDatesSessionsDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getExamDatesSessionsDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Withdraws a session from the public site (back to « to verify »).
 */
export type examDatesSessionsUnverifyCreateResponse200 = {
  data: ExamSession
  status: 200
}
    
export type examDatesSessionsUnverifyCreateResponseSuccess = (examDatesSessionsUnverifyCreateResponse200) & {
  headers: Headers;
};
;

export type examDatesSessionsUnverifyCreateResponse = (examDatesSessionsUnverifyCreateResponseSuccess)

export const getExamDatesSessionsUnverifyCreateUrl = (id: string,) => {


  

  return `/api/v1/exam-dates/sessions/${id}/unverify/`
}

export const examDatesSessionsUnverifyCreate = async (id: string, options?: RequestInit): Promise<examDatesSessionsUnverifyCreateResponse> => {
  
  return apiFetch<examDatesSessionsUnverifyCreateResponse>(getExamDatesSessionsUnverifyCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getExamDatesSessionsUnverifyCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examDatesSessionsUnverifyCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof examDatesSessionsUnverifyCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['examDatesSessionsUnverifyCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof examDatesSessionsUnverifyCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  examDatesSessionsUnverifyCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExamDatesSessionsUnverifyCreateMutationResult = NonNullable<Awaited<ReturnType<typeof examDatesSessionsUnverifyCreate>>>
    
    export type ExamDatesSessionsUnverifyCreateMutationError = unknown

    export const useExamDatesSessionsUnverifyCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examDatesSessionsUnverifyCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof examDatesSessionsUnverifyCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getExamDatesSessionsUnverifyCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * « Vérifié » : the team checked the date on the official page → public.
 */
export type examDatesSessionsVerifyCreateResponse200 = {
  data: ExamSession
  status: 200
}
    
export type examDatesSessionsVerifyCreateResponseSuccess = (examDatesSessionsVerifyCreateResponse200) & {
  headers: Headers;
};
;

export type examDatesSessionsVerifyCreateResponse = (examDatesSessionsVerifyCreateResponseSuccess)

export const getExamDatesSessionsVerifyCreateUrl = (id: string,) => {


  

  return `/api/v1/exam-dates/sessions/${id}/verify/`
}

export const examDatesSessionsVerifyCreate = async (id: string, options?: RequestInit): Promise<examDatesSessionsVerifyCreateResponse> => {
  
  return apiFetch<examDatesSessionsVerifyCreateResponse>(getExamDatesSessionsVerifyCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getExamDatesSessionsVerifyCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examDatesSessionsVerifyCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof examDatesSessionsVerifyCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['examDatesSessionsVerifyCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof examDatesSessionsVerifyCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  examDatesSessionsVerifyCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExamDatesSessionsVerifyCreateMutationResult = NonNullable<Awaited<ReturnType<typeof examDatesSessionsVerifyCreate>>>
    
    export type ExamDatesSessionsVerifyCreateMutationError = unknown

    export const useExamDatesSessionsVerifyCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examDatesSessionsVerifyCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof examDatesSessionsVerifyCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getExamDatesSessionsVerifyCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Official sessions. Deleting is only possible while « to verify » (a typing error); a
verified or past session is kept (history).
 */
export type examDatesSessionsImportCreateResponse200 = {
  data: ExamSessionImportResult
  status: 200
}
    
export type examDatesSessionsImportCreateResponseSuccess = (examDatesSessionsImportCreateResponse200) & {
  headers: Headers;
};
;

export type examDatesSessionsImportCreateResponse = (examDatesSessionsImportCreateResponseSuccess)

export const getExamDatesSessionsImportCreateUrl = () => {


  

  return `/api/v1/exam-dates/sessions/import/`
}

export const examDatesSessionsImportCreate = async (examSessionImportRequest: ExamSessionImportRequest, options?: RequestInit): Promise<examDatesSessionsImportCreateResponse> => {
    const formData = new FormData();
formData.append(`file`, examSessionImportRequest.file)

  return apiFetch<examDatesSessionsImportCreateResponse>(getExamDatesSessionsImportCreateUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}




export const getExamDatesSessionsImportCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examDatesSessionsImportCreate>>, TError,{data: ExamSessionImportRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof examDatesSessionsImportCreate>>, TError,{data: ExamSessionImportRequest}, TContext> => {

const mutationKey = ['examDatesSessionsImportCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof examDatesSessionsImportCreate>>, {data: ExamSessionImportRequest}> = (props) => {
          const {data} = props ?? {};

          return  examDatesSessionsImportCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExamDatesSessionsImportCreateMutationResult = NonNullable<Awaited<ReturnType<typeof examDatesSessionsImportCreate>>>
    export type ExamDatesSessionsImportCreateMutationBody = ExamSessionImportRequest
    export type ExamDatesSessionsImportCreateMutationError = unknown

    export const useExamDatesSessionsImportCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examDatesSessionsImportCreate>>, TError,{data: ExamSessionImportRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof examDatesSessionsImportCreate>>,
        TError,
        {data: ExamSessionImportRequest},
        TContext
      > => {

      const mutationOptions = getExamDatesSessionsImportCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * « Rechercher les prochaines sessions » for one exam (or all) of one country.
 */
export type examDatesSessionsResearchCreateResponse202 = {
  data: SessionResearch
  status: 202
}
    
export type examDatesSessionsResearchCreateResponseSuccess = (examDatesSessionsResearchCreateResponse202) & {
  headers: Headers;
};
;

export type examDatesSessionsResearchCreateResponse = (examDatesSessionsResearchCreateResponseSuccess)

export const getExamDatesSessionsResearchCreateUrl = () => {


  

  return `/api/v1/exam-dates/sessions/research/`
}

export const examDatesSessionsResearchCreate = async (researchRequestRequest: ResearchRequestRequest, options?: RequestInit): Promise<examDatesSessionsResearchCreateResponse> => {
  
  return apiFetch<examDatesSessionsResearchCreateResponse>(getExamDatesSessionsResearchCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      researchRequestRequest,)
  }
);}




export const getExamDatesSessionsResearchCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examDatesSessionsResearchCreate>>, TError,{data: ResearchRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof examDatesSessionsResearchCreate>>, TError,{data: ResearchRequestRequest}, TContext> => {

const mutationKey = ['examDatesSessionsResearchCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof examDatesSessionsResearchCreate>>, {data: ResearchRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  examDatesSessionsResearchCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ExamDatesSessionsResearchCreateMutationResult = NonNullable<Awaited<ReturnType<typeof examDatesSessionsResearchCreate>>>
    export type ExamDatesSessionsResearchCreateMutationBody = ResearchRequestRequest
    export type ExamDatesSessionsResearchCreateMutationError = unknown

    export const useExamDatesSessionsResearchCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examDatesSessionsResearchCreate>>, TError,{data: ResearchRequestRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof examDatesSessionsResearchCreate>>,
        TError,
        {data: ResearchRequestRequest},
        TContext
      > => {

      const mutationOptions = getExamDatesSessionsResearchCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    